import script from "./ButtonShape.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonShape.vue?vue&type=script&setup=true&lang=js"

import "./ButtonShape.vue?vue&type=style&index=0&id=4276aa33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4276aa33"]])

export default __exports__